const { createAction } = require('../helpers')

const {
  GET_SPECIFICATION_LIST,
  GET_SPECIFICATION_LIST_SUCCESS,
  GET_SPECIFICATION_LIST_ERROR,
  GET_SPECIFICATION_LIST_RESET,

  GET_SPECIFICATION,
  GET_SPECIFICATION_SUCCESS,
  GET_SPECIFICATION_ERROR,
  GET_SPECIFICATION_RESET,

  CREATE_SPECIFICATION,
  CREATE_SPECIFICATION_SUCCESS,
  CREATE_SPECIFICATION_ERROR,
  CREATE_SPECIFICATION_RESET,

  UPDATE_SPECIFICATION,
  UPDATE_SPECIFICATION_SUCCESS,
  UPDATE_SPECIFICATION_ERROR,
  UPDATE_SPECIFICATION_RESET,

  DELETE_SPECIFICATION,
  DELETE_SPECIFICATION_SUCCESS,
  DELETE_SPECIFICATION_ERROR,
  DELETE_SPECIFICATION_RESET,

  GET_SPECIFICATION_PRICE,
  GET_SPECIFICATION_PRICE_SUCCESS,
  GET_SPECIFICATION_PRICE_ERROR,
  GET_SPECIFICATION_PRICE_RESET,
} = require('./constants')

const getSpecificationList = ({ search, take, skip }) => createAction(GET_SPECIFICATION_LIST, { search, take, skip })
const getSpecificationListSuccess = data => createAction(GET_SPECIFICATION_LIST_SUCCESS, { data })
const getSpecificationListError = error => createAction(GET_SPECIFICATION_LIST_ERROR, { error })
const getSpecificationListReset = () => createAction(GET_SPECIFICATION_LIST_RESET)

const getSpecification = id => createAction(GET_SPECIFICATION, { id })
const getSpecificationSuccess = data => createAction(GET_SPECIFICATION_SUCCESS, { data })
const getSpecificationError = error => createAction(GET_SPECIFICATION_ERROR, { error })
const getSpecificationReset = () => createAction(GET_SPECIFICATION_RESET)

const createSpecification = specificationData => createAction(CREATE_SPECIFICATION, { specificationData })
const createSpecificationSuccess = data => createAction(CREATE_SPECIFICATION_SUCCESS, { data })
const createSpecificationError = error => createAction(CREATE_SPECIFICATION_ERROR, { error })
const createSpecificationReset = () => createAction(CREATE_SPECIFICATION_RESET)

const updateSpecification = ({ id, specificationData }) => createAction(UPDATE_SPECIFICATION, { id, specificationData })
const updateSpecificationSuccess = data => createAction(UPDATE_SPECIFICATION_SUCCESS, { data })
const updateSpecificationError = error => createAction(UPDATE_SPECIFICATION_ERROR, { error })
const updateSpecificationReset = () => createAction(UPDATE_SPECIFICATION_RESET)

const deleteSpecification = ({ id }) => createAction(DELETE_SPECIFICATION, { id })
const deleteSpecificationSuccess = data => createAction(DELETE_SPECIFICATION_SUCCESS, { data })
const deleteSpecificationError = error => createAction(DELETE_SPECIFICATION_ERROR, { error })
const deleteSpecificationReset = () => createAction(DELETE_SPECIFICATION_RESET)

const getSpecificationPrice = paramsData => createAction(GET_SPECIFICATION_PRICE, { paramsData })
const getSpecificationPriceSuccess = data => createAction(GET_SPECIFICATION_PRICE_SUCCESS, { data })
const getSpecificationPriceError = error => createAction(GET_SPECIFICATION_PRICE_ERROR, { error })
const getSpecificationPriceReset = () => createAction(GET_SPECIFICATION_PRICE_RESET)

module.exports = {
  getSpecificationList,
  getSpecificationListSuccess,
  getSpecificationListError,
  getSpecificationListReset,
  getSpecification,
  getSpecificationSuccess,
  getSpecificationError,
  getSpecificationReset,
  createSpecification,
  createSpecificationSuccess,
  createSpecificationError,
  createSpecificationReset,
  updateSpecification,
  updateSpecificationSuccess,
  updateSpecificationError,
  updateSpecificationReset,
  deleteSpecification,
  deleteSpecificationSuccess,
  deleteSpecificationError,
  deleteSpecificationReset,
  getSpecificationPrice,
  getSpecificationPriceSuccess,
  getSpecificationPriceError,
  getSpecificationPriceReset,
}
